import "./chunk-J43GMYXM.js";

// node_modules/unity-webgl/dist/index.esm.js
var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
    d2.__proto__ = b2;
  } || function(d2, b2) {
    for (var p in b2)
      if (Object.prototype.hasOwnProperty.call(b2, p))
        d2[p] = b2[p];
  };
  return extendStatics(d, b);
};
function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
    throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() {
    this.constructor = d;
  }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function() {
  __assign = Object.assign || function __assign2(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p))
          t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}
function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() {
    if (t[0] & 1)
      throw t[1];
    return t[1];
  }, trys: [], ops: [] }, f, y, t, g;
  return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
    return this;
  }), g;
  function verb(n) {
    return function(v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f)
      throw new TypeError("Generator is already executing.");
    while (_)
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done)
          return t;
        if (y = 0, t)
          op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return { value: op[1], done: false };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2])
              _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    if (op[0] & 5)
      throw op[1];
    return { value: op[0] ? op[1] : void 0, done: true };
  }
}
var UNITY_GLOBAL_NAME = "__UnityLib__";
var EventMap = /* @__PURE__ */ new Map();
var EventBus = function() {
  function EventBus2() {
    if (window !== void 0) {
      if (window[UNITY_GLOBAL_NAME] === void 0) {
        window[UNITY_GLOBAL_NAME] = {};
      }
    }
  }
  EventBus2.prototype.setGlobalName = function(name) {
    if (window[name]) {
      console.error("UnityWebgl: window.".concat(name, " already exists."));
    } else {
      var oName = UNITY_GLOBAL_NAME;
      window[name] = window[UNITY_GLOBAL_NAME];
      UNITY_GLOBAL_NAME = name;
      delete window[oName];
    }
  };
  EventBus2.prototype.on = function(eventName, eventListener) {
    EventMap.set(eventName, eventListener);
    if (window[UNITY_GLOBAL_NAME] !== void 0) {
      window[UNITY_GLOBAL_NAME][eventName] = eventListener;
    }
    return this;
  };
  EventBus2.prototype.once = function(eventName, eventListener) {
    var listener = function() {
      if (eventListener) {
        eventListener.apply(this, arguments);
      }
      this.off(eventName);
    };
    this.on(eventName, listener.bind(this));
    return this;
  };
  EventBus2.prototype.off = function(eventName) {
    EventMap.delete(eventName);
    if (window[UNITY_GLOBAL_NAME] !== void 0) {
      delete window[UNITY_GLOBAL_NAME][eventName];
    }
    return this;
  };
  EventBus2.prototype.clear = function() {
    if (window[UNITY_GLOBAL_NAME] !== void 0) {
      EventMap.forEach(function(_v, k) {
        delete window[UNITY_GLOBAL_NAME][k];
      });
    }
    EventMap.clear();
    return this;
  };
  EventBus2.prototype.emit = function(eventName) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      args[_i - 1] = arguments[_i];
    }
    var event = EventMap.get(eventName);
    if (event !== void 0) {
      event.apply(this, args);
    }
    return this;
  };
  return EventBus2;
}();
function unityLoader(src, _a) {
  var resolve = _a.resolve, reject = _a.reject;
  if (!src) {
    reject && reject(new Error("UnityWebgl: loaderUrl not found."));
    return void 0;
  }
  if (typeof window.createUnityInstance === "function") {
    resolve && resolve();
    return void 0;
  }
  function handler(code) {
    if (code === "ready") {
      resolve && resolve();
    } else {
      reject && reject(new Error("'UnityWebgl: ".concat(src, "' loading failure.")));
    }
  }
  var script = document.querySelector('script[src="'.concat(src, '"]'));
  if (script === null) {
    script = document.createElement("script");
    script.src = src;
    script.crossOrigin = "anonymous";
    script.async = true;
    script.setAttribute("data-status", "loading");
    document.body.appendChild(script);
    var setAttributeFromEvent = function(event) {
      var _status = event.type === "load" ? "ready" : "error";
      script === null || script === void 0 ? void 0 : script.setAttribute("data-status", _status);
    };
    script.addEventListener("load", setAttributeFromEvent);
    script.addEventListener("error", setAttributeFromEvent);
  } else {
    script.crossOrigin = "anonymous";
    handler(script.getAttribute("data-status"));
  }
  var setStateFromEvent = function(event) {
    handler(event.type === "load" ? "ready" : "error");
  };
  script.addEventListener("load", setStateFromEvent);
  script.addEventListener("error", setStateFromEvent);
  return function() {
    if (script) {
      script.removeEventListener("load", setStateFromEvent);
      script.removeEventListener("error", setStateFromEvent);
      document.body.removeChild(script);
    }
  };
}
var isPlainObject = function(arg) {
  return Object.prototype.toString.call(arg) === "[object Object]";
};
function queryCanvas(canvas) {
  if (canvas instanceof HTMLCanvasElement) {
    return canvas;
  } else if (typeof canvas === "string") {
    return document.querySelector(canvas);
  } else {
    console.warn("UnityWebgl: CanvasElement not found.");
    return null;
  }
}
var DefaultConfig = {
  streamingAssetsUrl: "StreamingAssets",
  companyName: "Unity.com",
  productName: "Unity"
};
function generateUnityInstanceParameters(unity) {
  var unityParameters = __assign({}, unity.unityConfig);
  unityParameters.print = function(message) {
    unity.emit("debug", message);
  };
  unityParameters.printError = function(message) {
    unity.emit("error", message);
  };
  return unityParameters;
}
var UnityWebgl = function(_super) {
  __extends(UnityWebgl2, _super);
  function UnityWebgl2(canvas, options) {
    var _this = _super.call(this) || this;
    _this.canvasElement = null;
    _this.unityLoader = null;
    _this.unityInstance = null;
    if (isPlainObject(canvas) && !options) {
      _this.unityConfig = Object.assign({}, DefaultConfig, canvas);
    } else {
      _this.unityConfig = Object.assign({}, DefaultConfig, options);
      var _canvas = queryCanvas(canvas);
      if (_canvas) {
        _this.create(_canvas);
      }
    }
    return _this;
  }
  UnityWebgl2.prototype.create = function(canvas) {
    if (this.unityInstance && this.canvasElement && this.unityLoader) {
      console.warn("UnityWebgl: Unity Instance already exists");
      return void 0;
    }
    var canvasEl = queryCanvas(canvas);
    if (!canvasEl) {
      console.warn("UnityWebgl: CanvasElement not found.");
      return void 0;
    }
    this.canvasElement = canvasEl;
    var ctx = this;
    var config = generateUnityInstanceParameters(this);
    var loader = unityLoader(config.loaderUrl, {
      resolve: function() {
        try {
          window.createUnityInstance(canvasEl, config, function(val) {
            return ctx._setProgression(val);
          }).then(function(unity) {
            ctx.unityInstance = unity;
            ctx.emit("created", unity);
          }).catch(function(err) {
            ctx.unityInstance = null;
            ctx.emit("error", err);
          });
        } catch (err) {
          ctx.unityInstance = null;
          ctx.emit("error", err);
        }
      },
      reject: function(err) {
        console.error("UnityWebgl: ", err === null || err === void 0 ? void 0 : err.message);
      }
    });
    if (typeof loader === "function") {
      this.unityLoader = loader;
    } else {
      console.error();
    }
  };
  UnityWebgl2.prototype._setProgression = function(val) {
    if (val === 1) {
      this.emit("loaded");
    }
    this.emit("progress", val);
  };
  UnityWebgl2.prototype.send = function(objectName, methodName, params) {
    if (this.unityInstance !== null) {
      if (params === void 0 || params === null) {
        this.unityInstance.SendMessage(objectName, methodName);
      } else {
        var _params = typeof params === "object" ? JSON.stringify(params) : params;
        this.unityInstance.SendMessage(objectName, methodName, _params);
      }
    } else {
      console.warn("UnityWebgl: Unable to Send Message while Unity is not Instantiated.");
    }
    return this;
  };
  UnityWebgl2.prototype.requestPointerLock = function() {
    var _a, _b;
    var canvasElement = this.canvasElement || ((_b = (_a = this.unityInstance) === null || _a === void 0 ? void 0 : _a.Module) === null || _b === void 0 ? void 0 : _b.canvas);
    if (canvasElement) {
      canvasElement.requestPointerLock();
    }
  };
  UnityWebgl2.prototype.takeScreenshot = function(dataType, quality) {
    var _a, _b, _c;
    if (dataType === void 0) {
      dataType = "image/jpeg";
    }
    var canvasElement = this.canvasElement || ((_b = (_a = this.unityInstance) === null || _a === void 0 ? void 0 : _a.Module) === null || _b === void 0 ? void 0 : _b.canvas);
    if (!canvasElement) {
      console.warn("UnityWebgl: Unable to Take Screenshot while Unity is not Instantiated or Canvas is not available.");
      return;
    }
    if (((_c = this.unityConfig.webglContextAttributes) === null || _c === void 0 ? void 0 : _c.preserveDrawingBuffer) !== true) {
      console.warn('UnityWebgl: Taking a screenshot requires "preserveDrawingBuffer".');
    }
    return canvasElement.toDataURL(dataType, quality);
  };
  UnityWebgl2.prototype.setFullscreen = function(enabled) {
    if (!this.unityInstance) {
      console.warn("UnityWebgl: Unable to Set Fullscreen while Unity is not Instantiated.");
      return;
    }
    this.unityInstance.SetFullscreen(enabled ? 1 : 0);
  };
  UnityWebgl2.prototype.unload = function() {
    var _this = this;
    if (this.unityInstance === null) {
      console.warn("UnityWebgl: Unable to Quit Unity while Unity is not Instantiated.");
      return Promise.reject();
    }
    if (this.unityLoader) {
      this.unityLoader();
      this.unityLoader = null;
    }
    return this.unityInstance.Quit().then(function() {
      _this.unityInstance = null;
      _this.emit("destroyed");
    });
  };
  UnityWebgl2.prototype.destroy = function() {
    return __awaiter(this, void 0, void 0, function() {
      var canvas;
      return __generator(this, function(_a) {
        switch (_a.label) {
          case 0:
            if (this.unityInstance === null || !this.unityInstance.Module.canvas) {
              console.warn("UnityWebgl: No Unity Instance found.");
              return [2, Promise.reject()];
            }
            canvas = this.unityInstance.Module.canvas;
            document.body.appendChild(canvas);
            canvas.style.display = "none";
            return [
              4,
              this.unload()
            ];
          case 1:
            _a.sent();
            canvas.remove();
            return [2];
        }
      });
    });
  };
  return UnityWebgl2;
}(EventBus);
export {
  UnityWebgl as default
};
/*!
 * unity-webgl.js v3.2.0
 * (c) 2022 Mervin<mengqing723@gmail.com>
 * Released under the MIT License.
 */
//# sourceMappingURL=unity-webgl.js.map
